/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {BaseFormFieldDirective} from '../../base-form-field.directive';
import {FieldLabelComponent} from '../field-label/field-label.component';
import {IxModule} from '@siemens/ix-angular';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-document-input',
  imports: [
    CommonModule,
    FieldLabelComponent,
    IxModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  templateUrl: './document-input.component.html',
  styleUrl: '../input-components.scss',
})
export class DocumentInputComponent extends BaseFormFieldDirective {
  validatedImageUrl?: string;

  constructor() {
    super();
  }

  override onControlValueInitialized() {
    super.onControlValueInitialized();
    const url = this.control.getRawValue();
    this.validateImageUrl(url);
  }

  override async onControlValueChanged(value: string) {
    await super.onControlValueChanged(value, this.saveFunction);
    this.validateImageUrl(value);
  }

  validateImageUrl(url: string) {
    if (!url) {
      this.validatedImageUrl = undefined;
      return;
    }

    // Basic URL validation
    try {
      new URL(url);
    } catch {
      this.validatedImageUrl = undefined;
      return;
    }

    // Image loading validation
    const img = new Image();
    img.onload = () => {
      this.validatedImageUrl = url;
    };
    img.onerror = () => {
      this.validatedImageUrl = undefined;
    };
    img.src = url;
  }
}
